import { render, staticRenderFns } from "./UpgradePlanModal.vue?vue&type=template&id=353ff10a&"
import script from "./UpgradePlanModal.vue?vue&type=script&lang=js&"
export * from "./UpgradePlanModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports